import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { behindScenes } from "@/mocks/gossip";

type Bts = (typeof behindScenes)[number];

function BtsCard({ item }: { item: Bts }) {
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(item.likes);

  const toggleLike = () => {
    setLiked((prev) => {
      setCount((c) => (prev ? c - 1 : c + 1));
      return !prev;
    });
  };

  return (
    <article className="reveal group rounded-2xl border border-background-200 bg-background-50 overflow-hidden flex flex-col">
      <div className="relative w-full h-52 md:h-56 overflow-hidden">
        <img
          src={item.image}
          alt={`《${item.drama}》幕后花絮：${item.title}`}
          title={`${item.drama} 幕后花絮 拍摄现场`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-950/70 text-background-50 text-[11px] font-label backdrop-blur">
          {item.category}
        </span>
      </div>

      <div className="p-5 flex flex-col flex-1">
        <span className="inline-flex items-center gap-1.5 text-xs text-primary-600 font-label mb-2">
          <i className="ri-clapperboard-line"></i>
          《{item.drama}》
        </span>
        <h3 className="font-heading font-semibold text-lg text-foreground-950 leading-snug">
          {item.title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">{item.desc}</p>

        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between">
          <button
            type="button"
            onClick={toggleLike}
            aria-pressed={liked}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-label transition-colors cursor-pointer border ${
              liked
                ? "bg-primary-500 border-primary-500 text-background-50"
                : "bg-background-50 border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            <i className={liked ? "ri-heart-fill" : "ri-heart-line"}></i>
            {liked ? "已收藏" : "收藏花絮"}
          </button>
          <span className="text-xs text-foreground-500 font-label inline-flex items-center gap-1.5">
            <i className="ri-thumb-up-line"></i>
            {count.toLocaleString()} 人觉得有趣
          </span>
        </div>
      </div>
    </article>
  );
}

export default function BtsSection() {
  return (
    <section id="bts" className="relative w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="幕后花絮"
          title="正片之外，还有这些名场面"
          desc="即兴台词、道具细节、通宵拍摄……花絮区把镜头背后的故事单独拎出来。每条都标了所属剧集和主题，喜欢哪部就点哪条看。"
          accent="accent"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {behindScenes.map((item) => (
            <BtsCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}